(() => {
  if (window.feIncontinenceReady) return;
  window.feIncontinenceReady = true;
  function initialize(root = document) {
    root.querySelectorAll('[data-fe-inc-product]').forEach(card => {
      if (card.dataset.feIncReady) return;
      card.dataset.feIncReady = 'true';
      const select = card.querySelector('[data-fe-inc-size]');
      const submit = card.querySelector('[data-fe-inc-submit]');
      const price = card.querySelector('[data-fe-inc-price]');
      if (!select || !submit) return;
      function update() {
        const option = select.selectedOptions[0];
        submit.disabled = !option || !option.value || option.disabled;
        if (option?.dataset.price && price) price.textContent = option.dataset.price;
      }
      select.addEventListener('change', update);
      card.querySelector('form')?.addEventListener('submit', event => {
        if (!select.value || select.selectedOptions[0]?.disabled) {
          event.preventDefault();
          select.reportValidity();
        }
      }, { capture: true });
      update();
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => initialize(), {once:true});
  else initialize();
  document.addEventListener('shopify:section:load', event => initialize(event.target));
})();
